var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('page',{attrs:{"custom-style":{
      paddingBottom: _vm.showBottom ? '60px' : '0',
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}},[_c('div',{staticClass:"panel"},[_c('div',{attrs:{"id":"keyContent"},domProps:{"innerHTML":_vm._s(_vm.content)}})])]),(_vm.showBottom)?_c('div',{staticClass:"bottom-panel"},[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.agreenClick(false)}}},[_vm._v("返回")]),_c('div',{staticClass:"btn agreen",on:{"click":function($event){return _vm.agreenClick(true)}}},[_vm._v("同意")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }